import { render, staticRenderFns } from "./ManagementNavigation.vue?vue&type=template&id=1431b8d7&"
import script from "./ManagementNavigation.vue?vue&type=script&lang=js&"
export * from "./ManagementNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports